module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Productdetails"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default",
    staticStyle: {
      "display": "block"
    }
  }, [_c('h6', [_vm._v("Voer onderstaande gegevens in om het product in te boeken of sluit dit scherm")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    attrs: {
      "onsubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Barcode"
    }
  }, [_vm._v("Barcode:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.gtin),
      expression: "product.gtin"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "Barcode"
    },
    domProps: {
      "value": (_vm.product.gtin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "gtin", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Location"
    }
  }, [_vm._v("Locatie:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.location),
      expression: "product.location"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "Location"
    },
    domProps: {
      "value": (_vm.product.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "location", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "ProductTitle"
    }
  }, [_vm._v("Naam:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.name),
      expression: "product.name"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "ProductTitle"
    },
    domProps: {
      "value": (_vm.product.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Quantity"
    }
  }, [_vm._v("Aantal:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.stock_quantity),
      expression: "product.stock_quantity"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "id": "Quantity"
    },
    domProps: {
      "value": (_vm.product.stock_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "stock_quantity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Brand"
    }
  }, [_vm._v("Merk:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.brands,
      "placeholder": "Selecteer een leverancier",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔",
      "allow-input": ""
    },
    model: {
      value: (_vm.product.brand),
      callback: function($$v) {
        _vm.$set(_vm.product, "brand", $$v)
      },
      expression: "product.brand"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Price"
    }
  }, [_vm._v("Prijs:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.price),
      expression: "product.price"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "id": "Price"
    },
    domProps: {
      "value": (_vm.product.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "price", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.createProduct
    }
  }, [_vm._v("Opslaan")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64af7aea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/products/CreateProductModal.vue
// module id = 725
// module chunks = 1